import React, { useState, useEffect } from 'react';
import Switch from 'react-switch';
import styled from '@emotion/styled';
import { useResource, useFetcher } from 'rest-hooks';
import StoryResource from '../resources/StoryResource';
import NotificationsPortal from './NotificationsPortal';

const OffsetSpan = styled.span`
    margin: 0px 6px 0px 5px;
    color: #666;
    font-weight: 500;
    font-size: 13px;
    line-height: 32px;
    letter-spacing: 0;
`;

const ClockIcon = styled.span`
    position: relative;
    top: 2px;
`

const OnHoldSwitchContainer = styled.div`
  display: inline;

  & i[type="clock"]{
    font-size: 24px;
    position: relative;
    top: 5px;
  }

  & i[type="clock"] span{
  }

  & .react-switch-bg{
    border: 1px solid ${props => props.active ? '#03899F' : '#D1D1D1' };
  }

  & .react-switch-bg div svg{
    margin-left: 6px;
  }

  & .react-switch-handle{
    border: 1px solid ${props => props.active ? '#03899F' : '#D1D1D1'} !important;
  }
`;

const bluePrimary = '#00a6c2';

const onHoldMessage = (
    <p>
        <b>⏰ This story is now on hold and a notification has been sent to your team!&nbsp;</b>
        You can find your “On Hold” Stories in <a href="/stories/library">the Stories tab</a> in the blue navigation bar.
    </p>
);

const offHoldMessage = (
    <p>
        <b>✅ This story is back In Progress and a notification has been sent to your team!&nbsp;</b>
        You can find your “In-Progress” Stories in <a href="/stories/library">the Stories tab</a> in the blue navigation bar.
    </p>
)

function OnHoldSwitch({ appData }) {
    const { storyId } = JSON.parse(appData);
    const [bannerOpen, setBannerOpen] = useState(false)
    const { id, onHold } = useResource(StoryResource.detailShape(), { id: storyId });
    const updateStory = useFetcher(StoryResource.updateShape());
    const labelText = onHold ? 'ON HOLD' : 'PUT ON HOLD';

    const onChange = async () => {
        await updateStory({ id }, { onHold: !onHold });
        if (onHold){
            const headers = {};
            headers['Accept'] = 'text/javascript, application/javascript';
            headers['X-Requested-With'] = 'XMLHttpRequest';
            const params = {
                onHoldToggled: true,
                onHoldState: onHold
            }
            const queryString = Object.entries(params)
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join('&');

            const endpoint = `/stories/${storyId}/workflow/edit?${queryString}`

            window.fetch(endpoint, {
                method: 'GET',
                headers
         }).then(data => data.text()).then(data => {
            eval(data);
         });
        }
       setBannerOpen(true);
    };


    useEffect(() => {
        const buttons = [].slice.call(document.querySelectorAll(".edit-button")).concat(document.getElementById("workflow-edit-button"))

        buttons.forEach(editButton => {
            if (onHold) {
                editButton.classList.add('disabled');
                editButton.setAttribute('style', "pointer-events: all");
                editButton.setAttribute('data-behavior', 'tooltip');
                editButton.setAttribute('data-tooltip-text', 'Remove the story from on hold to edit.');
                editButton.setAttribute('data-href', editButton.href);
                editButton.setAttribute('href', "javascript:void(0)");
            }
            else {
                editButton.setAttribute('data-behavior', 'disable-with-spinner');
                editButton.classList.remove('disabled');
                const storedHref = editButton.getAttribute('data-href');
                storedHref && editButton.setAttribute('href', storedHref);
            }
        })
    }, [onHold]);

    return (
        <OnHoldSwitchContainer active={onHold}>
            <NotificationsPortal show={bannerOpen} onClickX={() => setBannerOpen(false)} showX={true}>
                {onHold ? onHoldMessage : offHoldMessage}
            </NotificationsPortal>
            <ClockIcon>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 13.1401C10.3137 13.1401 13 10.4538 13 7.14014C13 3.82643 10.3137 1.14014 7 1.14014C3.68629 1.14014 1 3.82643 1 7.14014C1 10.4538 3.68629 13.1401 7 13.1401Z" stroke="#00A6C2" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M7 3.54004V7.14004L9.4 8.34004" stroke="#00A6C2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </ClockIcon>
            <OffsetSpan>{labelText}</OffsetSpan>
            <Switch
                className='js-on-hold-toggle'
                checked={onHold}
                onChange={onChange}
                checkedIcon={
                    <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.79755 6L0 3.15593L0.699387 2.44491L2.79755 4.57796L7.30061 0L8 0.711019L2.79755 6Z" fill="white"/>
                    </svg>
                }
                uncheckedIcon={false}
                onColor={bluePrimary}
                offColor={'#E3E4E5'}
                handleDiameter={16}
                height={20}
                width={36}
            />
        </OnHoldSwitchContainer>
    );
};

export default OnHoldSwitch



// WEBPACK FOOTER //
// ./app/javascript/client/components/onHoldPortal.jsx